module.exports = __webpack_public_path__ + "img/service1.6a31a097.jpg";